import React from 'react';
import { useTable, useSortBy, usePagination } from 'react-table';

export default function SearchTable(props) {
    const {
        getTableProps,
        getTableBodyProps,
        headerGroups,
        page,
        prepareRow,
        canPreviousPage,
        canNextPage,
        pageOptions,
        gotoPage,
        nextPage,
        previousPage,
        state: { pageIndex, pageSize },
    } = useTable(
        {
            columns: props.columns,
            data: props.data,
            disableMultiSort: true,
            disableSortRemove: true,
            initialState: props.initialState || {},
        },
        useSortBy,
        usePagination,
    );

    const sortedDesc = <span className="database-table__desc"></span>;
    const sortedAsc = <span className="database-table__asc"></span>;
    const sortedOff = <span className="database-table__asc" style={{ opacity: 0 }}></span>;

    const getPagination = function(pageIndex, numPages) {
        pageIndex++;
        const showPages = 5;
        const eitherSide = 2;
        let finish = numPages;
        let start = 1;
        let content = [];
        // logic for start and finish numbers
        if (numPages > showPages) {
            finish =
                pageIndex <= showPages
                    ? showPages
                    : pageIndex + eitherSide < numPages - eitherSide
                    ? pageIndex + eitherSide
                    : numPages;
            start = finish - showPages + 1;
        }
        // logic for additional jumps
        if (start >= showPages - 1) {
            content.push(
                <li key="1" onClick={() => gotoPage(0)}>
                    1
                </li>,
            );
            content.push(
                <li key="0" className="inactive">
                    ...
                </li>,
            );
        }
        for (let i = start; i < finish + 1; i++) {
            content.push(
                <li key={i} className={i === pageIndex ? 'active' : ''} onClick={() => gotoPage(i - 1)}>
                    {i}
                </li>,
            );
        }
        if (finish < numPages - 1) {
            content.push(
                <li key={numPages + 1} className="inactive">
                    ...
                </li>,
            );
            content.push(
                <li key={numPages} onClick={() => gotoPage(numPages - 1)}>
                    {numPages}
                </li>,
            );
        }
        return content;
    };

    const gotoURL = function(index) {
        window.location.href = props.data[index].url;
    };

    return (
        <>
            <table {...getTableProps()} className="database-table database-table--striped database-table--dynamic">
                <thead>
                    {headerGroups.map(headerGroup => (
                        <tr {...headerGroup.getHeaderGroupProps()}>
                            {headerGroup.headers.map(column => (
                                <th
                                    {...column.getHeaderProps(column.getSortByToggleProps())}
                                    className={column.only_desktop ? 'proxima u-hidden-mobile' : 'proxima'}>
                                    {column.render('Header')}
                                    {column.isSorted ? (column.isSortedDesc ? sortedDesc : sortedAsc) : sortedOff}
                                </th>
                            ))}
                        </tr>
                    ))}
                </thead>
                <tbody {...getTableBodyProps()}>
                    {page.map((row, index) => {
                        prepareRow(row);
                        return (
                            <tr {...row.getRowProps()} onClick={() => gotoURL(index)}>
                                {row.cells.map(cell => (
                                    <td
                                        {...cell.getCellProps()}
                                        className={cell.column.only_desktop ? 'u-hidden-mobile' : ''}>
                                        {cell.render('Cell')}
                                    </td>
                                ))}
                            </tr>
                        );
                    })}
                </tbody>
            </table>
            {props.data.length > pageSize && (
                <div className="datatable-paging proxima">
                    <button
                        onClick={() => previousPage()}
                        disabled={!canPreviousPage}
                        className="datatable-paging__prev">
                        Prev<span className="u-hidden-mobile">ious Page</span>
                    </button>
                    <ul className="datatable-paging__jump">{getPagination(pageIndex, pageOptions.length)}</ul>
                    <button onClick={() => nextPage()} disabled={!canNextPage} className="datatable-paging__next">
                        Next<span className="u-hidden-mobile"> Page</span>
                    </button>
                </div>
            )}
        </>
    );
}
